<ems-page-header
  [headerTitle]="dashboardState.welcomeMessage$ | async"
  caption="Welcome to Spense!"
>
</ems-page-header>

<ems-expense-summary
  (openModal)="onOpenModal($event)"
  (upload)="onUpload($event)"
  (uploaded)="onReceiptUploaded($event)"
  (receiptUploadSizeError)="onReceiptUploadSizeError($event)"
  [expensesLoading]="submitterState.submittedExpensesLoading$ | async"
  [summaryLoading]="dashboardState.summaryLoading$ | async"
  [submissionCounts]="dashboardState.submissions$ | async"
  [approvalCounts]="dashboardState.approvals$ | async"
  [recentSubmissions]="dashboardState.recentSubmissions$ | async"
  [isApprover]="dashboardState.isApprover$ | async"
  [proxy]="proxy$ | async"
></ems-expense-summary>
